import {
  GOAL_LABELS,
  narrowTags,
  narrowUserTypes,
  STRUCTURE_LABELS,
  TYPE_LABELS,
} from '~publish/pages/Create/Templates/labels'
import type { Template } from '~publish/pages/Create/Templates/types'

export { FormError } from './FormError'

export const DEFAULT_TEMPLATE_COLOR = '100, 149, 237'

/**
 * Type guard that checks whether a string value belongs to a typed
 * options array. Narrows `string` to the union of `value` literals
 * defined in the array.
 */
export function isOneOf<T extends string>(
  value: string,
  options: ReadonlyArray<{ readonly value: T }>,
): value is T {
  return options.some((o) => o.value === value)
}

/**
 * Admin GraphQL template fragment — the subset of fields we receive from
 * the admin API. Declared here as a structural type so the adapter can be
 * called with any object that satisfies it, without forcing callers to
 * import the generated fragment type.
 */
export type AdminTemplateInput = {
  id: string
  title: string
  body: string
  description: string
  emoji: string
  type: string
  goal: string
  structure: string
  userTypes: readonly string[]
  tags: readonly string[]
  featured: boolean
  createdAt: string
}

/**
 * Adapts an admin template (camelCase API enum values) to the `Template`
 * shape used by shared UI (display labels). Fields the admin API doesn't
 * surface are filled with neutral defaults.
 */
export function adaptAdminTemplate(template: AdminTemplateInput): Template {
  return {
    id: template.id,
    title: template.title,
    body: template.body,
    description: template.description,
    emoji: template.emoji,
    type: TYPE_LABELS[template.type] ?? 'Tip',
    goal: GOAL_LABELS[template.goal] ?? 'Engagement',
    structure: STRUCTURE_LABELS[template.structure] ?? 'Single Text',
    userTypes: narrowUserTypes(template.userTypes),
    tags: narrowTags(template.tags),
    createdAt: template.createdAt,
    color: DEFAULT_TEMPLATE_COLOR,
    linkedCampaigns: [],
    featured: template.featured,
  }
}
